import {
  DevFeatures,
  ProductFeatures,
} from '../types/enums/ProductFeatures.enum';
import { Products } from '../types/enums/Products.enum';
import type { IOrganization } from '../types/interfaces';

const DevFeaturesState: Record<DevFeatures, boolean> = {
  [DevFeatures.AutomationGenerate]: false,
  [DevFeatures.DataInsights]: true,
  [DevFeatures.Experimental]: true,
  [DevFeatures.WorkOrder]: true,
  [DevFeatures.WorkOsLogin]: false,
};

export class FeatureChecker {
  constructor(
    private readonly env: string,
    private readonly org: IOrganization,
  ) {}

  devFeatureEnabled(feature: DevFeatures): boolean {
    if (!['e2e', 'production'].includes(this.env)) {
      return DevFeaturesState[feature];
    }
    return false;
  }

  productFeatureEnabled(feature: ProductFeatures): boolean {
    return !!this.org.productFeatures?.includes(feature);
  }

  // Alerts aren't part of the Interval Data product, so orgs that only have
  // Interval Data don't get them.
  alertsEnabled(): boolean {
    const products = this.org.products ?? [];

    return !(
      products.length > 0 &&
      products.every((product) => product === Products.intervals)
    );
  }
}
